<template>
  <v-expansion-panels hover>
    <v-expansion-panel v-for="(mr, i) in matrixRow" :key="mr.questionOptId">
      <v-expansion-panel-header
        :color="
          errorMessage[i] && errorMessage[i].length > 0
            ? 'error lighten-3'
            : (Array.isArray(questionAnswer[i])
              ? questionAnswer[i].length > 0
              : questionAnswer[i] != null)
            ? 'primary lighten-2'
            : 'grey lighten-2'
        "
      >
        <v-img
          v-if="mr.attachment"
          class="mr-2"
          max-width="65px"
          max-height="65px"
          contain
          :src="mr.attachment.filePathUri"
        ></v-img>
        <span>{{ mr.optLabel }}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col align="center">
            <v-img
              v-if="mr.attachment"
              class="mr-2"
              max-width="200px"
              max-height="300px"
              contain
              :src="mr.attachment.filePathUri"
            ></v-img>
          </v-col>
        </v-row>
        <v-radio-group
          v-model="questionAnswer[i]"
          :error-messages="errorMessage[i]"
          :multiple="multiple"
        >
          <template v-if="!multiple">
            <v-radio
              v-for="(col, j) in matrixCol"
              :key="j"
              :value="col.questionOptId"
              :label="col.optLabel"
              @mousedown="setCurrentRowIdx(i)"
              :color="themeColor"
            >
              <template #label>
                <span class="my-2">{{ col.optLabel }}</span>
              </template>
            </v-radio>
          </template>
          <template v-else>
            <v-checkbox
              v-for="(col, j) in matrixCol"
              :key="j"
              :value="col.questionOptId"
              :label="col.optLabel"
              hide-details="auto"
              multiple
              :error="errorMessage[i] && errorMessage[i].length > 0"
              v-model="questionAnswer[i]"
              @mousedown="setCurrentRowIdx(i)"
              :color="themeColor"
            >
              <template #label>
                <span>{{ col.optLabel }}</span>
              </template>
            </v-checkbox>
          </template>
        </v-radio-group>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { validate } from "vee-validate";
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    },
    responseAnswer: Object,
  },
  computed: {
    matrixRow() {
      return this.question.questionOpts.filter((qo) => qo.matrixType == "ROW");
    },
    matrixCol() {
      return this.question.questionOpts.filter((qo) => qo.matrixType == "COL");
    },
    questionAnswers() {
      return this.questionAnswer.map((qa, i) => {
        // 매트릭스 각 행 문항 취득
        const question = this.matrixRow[i];
        return {
          questionId: question.questionId,
          questionMatrixId: question.questionOptId,
          questionAnswerVals: Array.isArray(this.questionAnswer[i])
            ? this.questionAnswer[i]
            : this.questionAnswer[i] == null ? [] : [this.questionAnswer[i]],
          questionType: this.question.questionType,
        };
      });
    },
  },
  data() {
    return {
      questionAnswer: [],
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
      isValids: [],
      currentRowIdx: null,
      skipInitialValidation: true,
    };
  },
  methods: {
    setCurrentRowIdx(idx) {
      this.currentRowIdx = idx;
    },
    async checkValidation(idx) {
      let rules = {};
      if (this.question.required) {
        rules["required"] = true;
      }
      let isValid = true;
      for (let index = 0; index < this.matrixRow.length; index++) {
        let rst = await validate(this.questionAnswer[index], rules, {
          name: this.$t("이 "),
        });
        //  this.errorMessage[index] = rst.errors;
        this.$set(this.isValids, index, rst.valid);
        if (index <= idx) {
          this.$set(this.errorMessage, index, rst.errors);
        }
        if (!rst.valid) {
          isValid = false;
        }
      }
      this.$emit("update:isValid", isValid);
    },
    setQuestionAnswer() {
      // 매트릭스 행별로 기존 답변 복원
      const questionAnswers = this.matrixRow.map((row) => {
        // 현재 행에 해당하는 답변만 조회
        const rowAnswers = this.responseAnswer.response.filter(
          (answer) => answer.questionMatrixId == row.questionOptId,
        );
        if (this.multiple) {
          // 복수 선택 행은 선택한 열 ID 목록 복원
          return rowAnswers.map((answer) => Number(answer.answerVal));
        }
        // 단일 선택 행은 선택한 열 ID 하나 복원
        return rowAnswers.length > 0 && rowAnswers[0].answerVal != null
          ? Number(rowAnswers[0].answerVal)
          : null;
      });

      // 최초 진입 시 답변이 없으면 초기 검증 패스
      this.skipInitialValidation = !questionAnswers.some((answer) =>
        Array.isArray(answer) ? answer.length > 0 : answer != null,
      );
      this.questionAnswer = questionAnswers;
    },
  },
  watch: {
    async questionAnswer() {
      if (this.skipInitialValidation) {
        this.skipInitialValidation = false;
        return;
      }
      await this.checkValidation(this.currentRowIdx);
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style>
</style>